import { cn } from 'src/shared/utils/cn'

const AuthContent = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return <div className={cn('mx-auto mt-2 w-full max-w-[500px]', className)}>{children}</div>
}

export default AuthContent
